export const colors = {
    primary: '#1a9fa1',
    secondary: '#388e3c',
    workspacePrimary: '#36494f',
    workspaceBackground: '#ededed',
};
